import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { PopoverBody } from "reactstrap";

import { PropTypeShapes } from "../../types";
import { withPopoverRepositionContext } from "./PopoverRepositionContext";

class PopoverResizableBody extends PureComponent {
  componentDidUpdate() {
    if (this.props.repositionPopover) {
      this.props.repositionPopover();
    }
  }

  render() {
    return <PopoverBody>{this.props.children}</PopoverBody>;
  }
}

PopoverResizableBody.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  repositionPopover: PropTypes.func
};

export default withPopoverRepositionContext(PopoverResizableBody);
